import React, { useEffect } from "react";
import { Box } from "@mui/system";
import Header from "../../../common/header/Header";
import ReportSettingsLayout from "./ReportSettingsLayout";
import Breadcrumb from "../../../common/header/Breadcrumb";

const ReportSettings = () => {
   useEffect(() => {
          window.scrollTo(0, 0);
      }, []);
  return (
    <Box sx={{ flexGrow: 1 }} className="report-setting-background">
      <Header />
      <Breadcrumb />
      <ReportSettingsLayout />
    </Box>
  );
};

export default ReportSettings;
